import { get } from 'axios'
// import store from '@/store'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

//post
function getCulturalAdvisorEnglishInterviewSchedulesAvailables (pIdCulturalAdvisor) {
    const URI = `${BASE_URL}/api/culturalAdvisors/${pIdCulturalAdvisor}/englishInterviewSchedulesAvailables`
    return get(URI, { headers })
}

export { getCulturalAdvisorEnglishInterviewSchedulesAvailables }